import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './home/index';
import NotFound from './notfound/index';
import Login from './login';
import Schema from './schema';
import { isMobile } from '@/common/utils/ua';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Mobile端暂不支持登录预约等功能, 后续支持后可删除Schema组件 */}
        <Route element={isMobile ? <Schema /> : <Home />} path='/' />
        <Route element={isMobile ? <Schema /> : <Login />} path='/login' />
        <Route element={<NotFound />} path='*' />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
